import React from 'react';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/pro-light-svg-icons';
import styled from 'styled-components';
import TrueImpactButton from 'shared/design-system/components/TrueImpactButton';
import { FeedbackSection } from './utils';

const getPreviousAndNextSection = (
  currentSection: FeedbackSection,
  allFeedbackSections: FeedbackSection[],
): {
  previous: FeedbackSection | undefined;
  next: FeedbackSection | undefined;
} => {
  const index = allFeedbackSections.findIndex(x => x === currentSection);
  if (index === -1) return { previous: undefined, next: undefined };
  if (index === 0) return { previous: undefined, next: allFeedbackSections[1] };
  if (index === allFeedbackSections.length - 1)
    return { previous: allFeedbackSections[index - 1], next: undefined };
  return {
    previous: allFeedbackSections[index - 1],
    next: allFeedbackSections[index + 1],
  };
};

interface SectionCommentFooterProps {
  currentSection: FeedbackSection;
  allFeedbackSections: FeedbackSection[];
  onDone: () => unknown;
  setCurrentSection: (section: FeedbackSection) => unknown;
}

const StyledDiv = styled.div`
  background-color: ${COLORS.grayLight};
  padding: ${SPACERS.small} ${SPACERS.medium};
  display: flex;
  justify-content: space-between;
  .left-column {
    display: flex;
    .left-icon {
      margin-right: ${SPACERS.tiny};
    }
    .right-icon {
      margin-left: ${SPACERS.tiny};
    }
    .previous {
      margin-right: ${SPACERS.tiny};
    }
    .next {
      margin-left: ${SPACERS.tiny};
    }
  }
`;

const SectionCommentFooter: React.FC<SectionCommentFooterProps> = ({
  currentSection,
  allFeedbackSections,
  onDone,
  setCurrentSection,
}) => {
  const { previous, next } = getPreviousAndNextSection(
    currentSection,
    allFeedbackSections,
  );
  return (
    <StyledDiv>
      <div className="left-column">
        <TrueImpactButton
          disabled={!previous}
          variant="secondary-large"
          className="previous"
          onClick={previous ? () => setCurrentSection(previous) : undefined}
        >
          <FontAwesomeIcon icon={faChevronLeft} className="left-icon" />
          Previous Section
        </TrueImpactButton>
        <TrueImpactButton
          disabled={!next}
          variant="secondary-large"
          className="next"
          onClick={next ? () => setCurrentSection(next) : undefined}
        >
          Next Section
          <FontAwesomeIcon icon={faChevronRight} className="right-icon" />
        </TrueImpactButton>
      </div>
      <TrueImpactButton onClick={onDone} className="right-column">
        Done With Feedback
      </TrueImpactButton>
    </StyledDiv>
  );
};

export default SectionCommentFooter;
